<template>
	<div class="wzry_content">
		<div class="wzry_form">
			<div class="utitle">
				勇士你好，
				<br />
				欢迎进入虚贝账号评估系统
			</div>

			<div class="form-input">
				<div class="finput" @click="toShow(tzs_num, 1)">
					<span class="num">挑战书数量</span>
					<span class="val">
						<em>{{ tzs_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>
				<div class="finput" @click="toShow(game_num, 2)">
					<span class="num">游戏币</span>
					<span class="val">
						<em>{{ game_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(tkt_num, 3)">
					<span class="num">天空套数量</span>
					<span class="val">
						<em>{{ tkt_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(wqzf_num, 4)">
					<span class="num">武器增幅</span>
					<span class="val">
						<em>{{ wqzf_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow(qszf_num, 5)">
					<span class="num">全身增幅</span>
					<span class="val">
						<em>{{ qszf_defaultData[0].text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>
			</div>
		</div>

		<div class="ftBtn">
			<router-link to="/" class="fh"><img src="/static/images/returnBtn.png" /></router-link>
			<div class="gz" @click="guzhi"><img src="/static/images/gzBtn.png" /></div>
		</div>

		<vue-pickers
			:show="show"
			:columns="columns"
			:defaultData="defaultData"
			:isRemember="true"
			:selectData="pickerData"
			@cancel="close"
			@confirm="confirmFn"
		></vue-pickers>
		<div class="mask" v-if="isMask"></div>
	</div>
</template>

<script>
import vuePickers from 'vue-pickers';
import { Toast } from 'mint-ui';
export default {
	name: 'home',
	components: { vuePickers, Toast },
	data: function () {
		return {
			id: this.$route.query.id,
			username: this.$route.query.username,
			isMask: false,
			show: false,
			type: 1,
			columns: 1,
			pickerData: {},
			defaultData: [],

			tzs_defaultData: [{ text: '0-5000', value: '300' }],
			tzs_num: {
				data1: [
					{ text: '0-5000', value: '300' },
					{ text: '5001-10000', value: '750' },
					{ text: '10001-15000', value: '1350' },
					{ text: '15001-20000', value: '1750' },
					{ text: '20000以上', value: '2200' }
				]
			},

			//游戏币
			game_defaultData: [{ text: '0w-2000w', value: '75' }],
			game_num: {
				data1: [
					{ text: '0w-2000w', value: '75' },
					{ text: '2000w-10000w', value: '400' },
					{ text: '10000w-50000w', value: '2000' },
					{ text: '50000w-100000w	', value: '4250' },
					{ text: '100000w以上', value: '6000' }
				]
			},

			//天空套数量
			tkt_defaultData: [{ text: '0套', value: '0' }],
			tkt_num: {
				data1: [
					{ text: '0套', value: '0' },
					{ text: '1-2套', value: '1499' },
					{ text: '3-5套', value: '6750' },
					{ text: '6-8套', value: '9750' },
					{ text: '8套以上	', value: '13500' }
				]
			},

			//武器增幅
			wqzf_defaultData: [{ text: '0~5', value: '1000' }],
			wqzf_num: {
				data1: [
					{ text: '0~5', value: '1000' },
					{ text: '6~10', value: '5000' },
					{ text: '11~12', value: '11000' },
					{ text: '13~14', value: '24000' },
					{ text: '15~16', value: '40000' },
					{ text: '16以上', value: '60000' }
				]
			},

			//全身增幅
			qszf_defaultData: [{ text: '0~5', value: '180' }],
			qszf_num: {
				data1: [
					{ text: '0~5', value: '180' },
					{ text: '6~10', value: '2000' },
					{ text: '11~12', value: '5000' },
					{ text: '13~14', value: '12000' },
					{ text: '14以上', value: '20000' }
				]
			}
		};
	},
	mounted() {
		document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
			WeixinJSBridge.call('hideToolbar');
		});
	},
	methods: {
		toShow(data, type) {
			console.log(data);
			this.show = true;
			this.isMask = true;
			this.pickerData = data;
			this.type = type;

			if (type === 1) {
				this.defaultData = this.tzs_defaultData;
			} else if (type === 2) {
				this.defaultData = this.game_defaultData;
			} else if (type === 3) {
				this.defaultData = this.tkt_defaultData;
			} else if (type === 4) {
				this.defaultData = this.wqzf_defaultData;
			} else if (type === 5) {
				this.defaultData = this.qszf_defaultData;
			}
		},
		close() {
			this.show = false;
			this.isMask = false;
		},
		confirmFn(val) {
			this.show = false;
			this.isMask = false;
			let type = this.type;
			if (type === 1) {
				this.tzs_defaultData = [val.select1];
			} else if (type === 2) {
				this.game_defaultData = [val.select1];
			} else if (type === 3) {
				this.tkt_defaultData = [val.select1];
			} else if (type === 4) {
				this.wqzf_defaultData = [val.select1];
			} else if (type === 5) {
				this.qszf_defaultData = [val.select1];
			}
		},
		guzhi() {
			var guzhi =
				Number(this.tzs_defaultData[0].value) +
				Number(this.game_defaultData[0].value) +
				Number(this.tkt_defaultData[0].value) +
				Number(this.wqzf_defaultData[0].value) +
				Number(this.qszf_defaultData[0].value);
			this.$router.push({ path: '/animation?id=3&username=' + this.username + '&amountValue=' + guzhi });
		}
	}
};

// 百度统计代码
var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?ad99db41be5b87499521b6c4980a6ec2';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.wzry_content {
	width: 10rem;
	margin: 0 auto;
	background: #1f1c27 url(/static/images/dxcys.jpg) no-repeat;
	background-size: 100% auto;
	.wzry_form {
		padding-top: px2rem(265rem);
		padding-bottom: px2rem(160rem);
		.utitle {
			color: #e3d9eb;
			font-weight: bold;
			font-size: px2rem(40rem);
			padding: 0 px2rem(70rem);
			margin-bottom: px2rem(64rem);
			letter-spacing: 1px;
			text-shadow: 2px 3px 3px #1b012f;
		}
		.form-input {
			text-align: center;
			.finput {
				width: px2rem(610rem);
				height: px2rem(90rem);
				line-height: px2rem(90rem);
				background: #36303c;
				color: #ffddb5;
				border-radius: 5px;
				padding: 0 px2rem(15rem);
				margin: 0 auto;
				font-size: px2rem(30rem);
				position: relative;
				text-align: left;
				overflow: hidden;
				margin-bottom: px2rem(30rem);
				.num {
					color: #8b7e98;
					float: left;
				}
				.val {
					color: #fff;
					float: right;
					em {
						font-style: normal;
						padding-right: px2rem(20rem);
					}
					img {
						width: px2rem(39rem);
						height: px2rem(23rem);
					}
				}
			}
		}
	}
	.ftBtn {
		display: flex;
		background: #000;
		padding: px2rem(20rem) 0;
		width: 100%;
		position: fixed;
		left: 0;
		bottom: 0;
		.fh {
			flex: 1;
			margin-left: px2rem(10rem);
			img {
				width: px2rem(252rem);
				height: px2rem(106rem);
			}
		}
		.gz {
			margin-right: px2rem(20rem);
			img {
				width: px2rem(436rem);
				height: px2rem(105rem);
			}
		}
	}

	.combox {
		width: px2rem(610rem);
		height: px2rem(130rem);
		margin: 0 auto;
		background: #34271f;
		margin-bottom: px2rem(40rem);
		border-radius: 5px;
		position: relative;
		.cn {
			color: #fff;
			padding: px2rem(25rem);
			font-size: px2rem(32rem);
		}
	}

	.combox:before {
		display: inline-block;
		width: 0;
		height: 0;
		border-width: px2rem(35rem);
		border-style: solid dashed dashed dashed;
		border-color: #34271f transparent transparent transparent;
		content: '';
		position: absolute;
		bottom: px2rem(-56rem);
		right: 50%;
		margin-left: px2rem(17.5rem);
	}

	.submitBtn {
		text-align: center;
		padding-top: px2rem(20rem);
		img {
			width: px2rem(616rem);
			height: px2rem(105rem);
		}
	}
	.copyRight {
		text-align: center;
		margin-top: px2rem(140rem);
		img {
			width: px2rem(419rem);
			height: px2rem(31rem);
		}
	}
}

.btnbox {
	display: flex;
	justify-content: center;
}
.btn {
	background: #2e68fa;
	color: #fff;
	padding: 5px 10px;
	display: inline-block;
	margin: 0 10px;
	font-size: 14px;
	border-radius: 4px;
}
.result {
	text-align: center;
	padding: 10px;
}
.isCopy {
	margin: 10px;
	border: 1px dashed red;
	text-align: center;
}

.wzry_content /deep/ .area_grid {
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	-webkit-border-image: url(/static/images/dotted.jpg) 30 30 round;
	-o-border-image: url(/static/images/dotted.jpg) 30 30 round;
	border-image: url(/static/images/dotted.jpg) 30 30 round;
}

.wzry_content /deep/ .area_ctrl {
	font-size: 12px;
	vertical-align: middle;
	background-color: #413c3c;
	color: #fff;
	margin: 0;
	height: auto;
	width: 100%;
	position: fixed;
	width: 100%;
	left: 0;
	bottom: 0;
	z-index: 9901;
	overflow: hidden;
}

.wzry_content /deep/ .area_btn_box {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-box-align: stretch;
	-ms-flex-align: stretch;
	align-items: stretch;
	background-color: #393333;
	position: relative;
}

.wzry_content /deep/ .tooth {
	color: #fff;
	height: 2em;
	line-height: 2em;
	text-align: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	line-clamp: 1;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	overflow: hidden;
}

.wzry_content /deep/ .area_btn {
	color: #999;
	font-size: 1.6em;
	line-height: 1em;
	text-align: center;
	padding: 0.8em 1em;
}

.wzry_content /deep/ .larea_finish {
	color: #ffddb5;
}

.wzry_content /deep/ .area_btn_box:before,
.wzry_content /deep/ .area_btn_box:after {
	content: '';
	position: absolute;
	height: 1px;
	width: 100%;
	display: block;
	background-color: transparent;
	z-index: 15;
	-webkit-transform: scaleY(0.33);
	transform: scaleY(0.33);
}

.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 999;
	background: #000;
	opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/pages/game/dxcys.vue